module.exports = __webpack_public_path__ + "img/box-arrow-in-down-right.05a69a23.svg";